const isPlainObject = (value: unknown): value is Record<string, unknown> =>
    typeof value === 'object' && value !== null && Object.getPrototypeOf(value) === Object.prototype;

// blank form values are stored as null, so whitespace-only strings become null instead of ''
export const normalizeTextInput = (value: unknown): unknown => {
    if (typeof value === 'string') {
        const trimmed = value.trim();
        if (trimmed === value) return value;
        return trimmed === '' ? null : trimmed;
    }
    if (Array.isArray(value)) return value.map(normalizeTextInput);
    if (isPlainObject(value)) {
        return Object.fromEntries(Object.entries(value).map(([key, entry]) => [key, normalizeTextInput(entry)]));
    }
    return value;
};
